import moment from 'moment'

export const handleAuthFail = (Code) => {
    const codesArray = [5044, 5004, 5003, 5043, 5042, 5047, 5139]
    if (codesArray.includes(Code)) {
        localStorage.removeItem("sadhan_user");
        window.location.replace("#/login")

        // window.location.reload()
    }
}

export const momentDate = (fomatDateInput) => {
    return moment(fomatDateInput).format('YYYY-MM-DD HH:mm:ss');
}

export const returnCurrentDate = () => {
    return moment()
}
